import { styled } from "@mui/material";

export const StyledPreloaderContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const StyledControlsContainer = styled("div")({
  marginRight: 50,
  verticalAlign: "top",
});
